import React from 'react';
import { useTranslation } from 'react-i18next';
import Text from '../Shared/Text';

const ShowTime = () => {
  const { t } = useTranslation();

  return (
    <Text
      html={
        <div
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: t('srtFileDurationFree'),
          }}
        />
      }
    />
  );
};

const srtFileDurationFeatures = ({ packages }) =>
  packages.map((pkg) => <ShowTime key={pkg.code} pkg={pkg} />);

export default srtFileDurationFeatures;
